import { Farben } from "../shared/farben"

function chartSettings(data) {
	return data?.charteinstellungen || {}
}

function hiddenSeries(data) {
	const hs = chartSettings(data)?.hidden_series
	return Array.isArray(hs) ? hs.map(String) : []
}

function visibleBySettings(data, id, defaultVisible = true) {
	return hiddenSeries(data).includes(String(id)) ? false : defaultVisible
}

export function seriesLiqui(data) {
	const konsolidiert = (data?.status || "konsolidiert") === "konsolidiert"
	const deckungsstockStack = konsolidiert ? "vertragswert" : "bruttowert_aufteilung"
	const deckungsstockLinkedTo = konsolidiert ? "bruttowert" : "bruttowert_zulagen"

	return [
		{
			name: "Vertragswert",
			id: "bruttowert",
			legendName: "Vertragswert",
			yAxis: 0,
			type: "area",
			color: farbeNettovermoegen,
			zIndex: 0,
			visible: visibleBySettings(data, "bruttowert", konsolidiert),
			showInLegend: konsolidiert,
			stack: "vertragswert",
			data: data.bruttowerte,
		},
		{
			name: "Vertragswert aus Zulagen",
			id: "bruttowert_zulagen",
			legendName: "Vertragswert aus Zulagen",
			yAxis: 0,
			type: "area",
			color: farbeZulagen,
			zIndex: 0,
			visible: visibleBySettings(data, "bruttowert_zulagen", !konsolidiert),
			showInLegend: !konsolidiert,
			stack: "bruttowert_aufteilung",
			data: data.bruttowerte_zulagen,
		},
		{
			name: "Vertragswert aus Beiträgen",
			id: "bruttowert_beitraege",
			legendName: "Vertragswert aus Beiträgen",
			yAxis: 0,
			type: "area",
			color: farbeBeitrag1,
			zIndex: 0,
			visible: visibleBySettings(data, "bruttowert_beitraege", !konsolidiert),
			showInLegend: !konsolidiert,
			stack: "bruttowert_aufteilung",
			data: data.bruttowerte_beitraege,
		},
		{
			name: "Deckungsstock",
			id: "deckungsstock",
			yAxis: 0,
			type: "area",
			color: farbeDeckungsstock,
			zIndex: 0,
			visible: visibleBySettings(data, "deckungsstock", true),
			showInLegend: false,
			stack: deckungsstockStack,
			linkedTo: deckungsstockLinkedTo,
			data: data.deckungsstoecke,
		},
		{
			name: "Zulagen",
			id: "zulagen",
			legendName: "Zulagen",
			yAxis: 1,
			type: "column",
			color: farbeZulagen,
			zIndex: 1,
			visible: visibleBySettings(data, "zulagen", true),
			stack: "ein_ausgaben",
			data: data.zulagen,
		},
		{
			name: "Beitrag",
			id: "beitrag",
			legendName: "Beitrag",
			yAxis: 1,
			type: "column",
			color: farbeBeitrag1,
			zIndex: 1,
			visible: visibleBySettings(data, "beitrag", true),
			stack: "ein_ausgaben",
			data: data.vorsorgebeitraege,
		},
		{
			name: "Leistung",
			id: "leistung",
			legendName: "Leistung",
			yAxis: 1,
			type: "column",
			color: farbeLeistung,
			zIndex: 1,
			visible: visibleBySettings(data, "leistung", true),
			stack: "ein_ausgaben",
			data: data.leistungen,
		},
	]
}

export function seriesSteuer(data) {
	const zvesBeitraege = Array.isArray(data?.zves) ? data.zves : []
	const zvesLeistungen = Array.isArray(data?.zves_leistungen) ? data.zves_leistungen : []

	return [
		{
			name: "steuerlicher Beitragseffekt",
			id: "zve_beitragsphase",
			legendName: "steuerlicher Beitragseffekt",
			type: "column",
			color: farbeBeitrag1,
			visible: visibleBySettings(data, "zve_beitragsphase", true),
			data: zvesBeitraege,
		},
		{
			name: "steuerpflichtiges Einkommen",
			id: "zve_leistungsphase",
			legendName: "steuerpflichtiges Einkommen",
			type: "column",
			color: Farben.zuVersteuerndesEinkommen,
			visible: visibleBySettings(data, "zve_leistungsphase", true),
			data: zvesLeistungen,
		},
		{
			name: "sozialpflichtiges Einkommen",
			id: "sozialpflichtiges_einkommen",
			legendName: "sozialpflichtiges Einkommen",
			type: "column",
			color: Farben.sozialpflichtigesEinkommen,
			stack: "sve",
			visible: visibleBySettings(data, "sozialpflichtiges_einkommen", true),
			data: data.sozialpflichtiges_einkommens,
		},
	]
}

export function seriesBuschutz(data) {
	return [
		{
			name: "Gesamte Versicherungsleistung",
			id: "bu_leistung",
			legendName: "Versicherungsleistung",
			yAxis: 0,
			type: "area",
			color: farbeLeistung,
			opacity: "0.5",
			zIndex: 0,
			visible: visibleBySettings(data, "bu_leistung", true),
			data: data.bu_leistungen,
		},
		{
			name: "Beitrag zur BU-Rente",
			id: "burente",
			legendName: "Beitrag zur BU-Rente",
			yAxis: 0,
			type: "column",
			color: farbeBeitrag1,
			zIndex: 0,
			visible: visibleBySettings(data, "burente", true),
			data: data.burente_beitraege,
		},
		{
			name: "Beitrag zur Beitragsbefreiung",
			id: "beitragsbefreiung",
			legendName: "Beitrag zur Beitragsbefreiung",
			yAxis: 0,
			type: "column",
			color: farbeBeitrag2,
			zIndex: 0,
			visible: visibleBySettings(data, "beitragsbefreiung", true),
			data: data.beitragsbefreiung_beitraege,
		},
	]
}
